import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { LANDING_ASSETS, LANDING_COLORS } from '../../content/landingContent';

const ClientLogosSection = () => (
  <Box component="section" sx={{ pt: { xs: 8, md: 4 }, pb: { xs: 5, md: 7 }, bgcolor: '#fff' }}>
    <Container maxWidth="lg">
      <Typography
        align="center"
        sx={{
          fontFamily: 'Cabin, sans-serif',
          fontWeight: 700,
          fontSize: { xs: 22, md: 28 },
          color: LANDING_COLORS.purple,
          mb: { xs: 3, md: 5 },
        }}
      >
        Birlikte büyüdüğümüz markalar
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center',
          gap: { xs: 3, md: 5 },
        }}
      >
        {LANDING_ASSETS.clientLogos.map((logo) => (
          <Box
            key={logo.name}
            component="img"
            src={logo.url}
            alt={logo.name}
            sx={{
              width: { xs: logo.width * 0.65, md: logo.width },
              height: { xs: logo.height * 0.65, md: logo.height },
              objectFit: 'contain',
              flexShrink: 0,
            }}
          />
        ))}
      </Box>
    </Container>
  </Box>
);

export default ClientLogosSection;
